export const toKebabCase = (str: string) =>
    str &&
    str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z][0-9]+/g)
        .map(x => x.toLowerCase())
        .join('-');

export const GetPropByString = (obj, propString) => {
    if (!propString) return obj;
    const properties = propString.split('.');
    return GetPropByString(obj[properties.shift()], properties.join('.'))
}

export function replaceDotsWithHyphens(str: string): string {
  return str.replace(/\./g, "-");
}

export function trimInput(value: string): string {
    if (value) {
        const trimmed = value.trim();
        return trimmed.length === 0 ? undefined : trimmed;
    }
}
